var React = require('react');

function CloseImg (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_141","data-name":"Group 141","transform":"translate(-1337.997 -151)"},[React.createElement("path",{"id":"Path","d":"M25.2,0a.883.883,0,0,1,.121,1.758l-.121.008H.889A.883.883,0,0,1,.769.008L.889,0Z","transform":"translate(1339.246 151) rotate(45)","key":0}),React.createElement("path",{"id":"Path-2","data-name":"Path","d":"M25.2,0a.883.883,0,0,1,.121,1.758l-.121.008H.889A.883.883,0,0,1,.769.008L.889,0Z","transform":"translate(1338 169.445) rotate(-45)","key":1})]));
}

CloseImg.defaultProps = {"width":"19.697","height":"19.694","viewBox":"0 0 19.697 19.694"};

module.exports = CloseImg;

CloseImg.default = CloseImg;
